<template>
  <b-card
    v-if="userData.roles.length!=0 && userData.roles[0].rol!=null"
    :class="{ 'border-primary': skin === 'dark', 'border-secondary border-lighten-5': skin === 'light' }"
  >
    <div class="d-flex mt-2 text-primary m-2">
      <feather-icon
        icon="UsersIcon"
        size="19"
      />
      <h4 class="mb-0 ml-50 text-primary">
        Roles
      </h4>
    </div>
    <template>
      <b-list-group
        class="my-2 w-100"
      >
        <b-list-group-item
          v-for="rolesv in userData.roles"
          :key="rolesv.rol"
          class=""
        >
          <feather-icon
            :icon="resolveUserrolIcon(rolesv.rol)"
            size="18"
            class="mr-50"
            :class="`text-${resolveUserrolVariant(rolesv.rol)}`"
          />
          <span
            class="align-text-top"
            :class="`text-${resolveUserrolVariant(rolesv.rol)}`"
          >{{ rolesv.rol }}</span>
          <br>
          <small
            v-if="rolesv.rol_activo===0"
            class="align-text-top"
          >Alguna vez fue {{ rolesv.rol }}<br>(cuenta con un historial en el sistema, por el momento, este rol está desactivado)</small>
        </b-list-group-item>
      </b-list-group>
    </template>
  </b-card>
</template>

<script>
import {
  BCard, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  configTableUsuarios,
} from '@/views/campus/usuarios/useUsuarios'
import store from '@/store'
import { computed } from '@vue/composition-api'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BListGroup,
    BListGroupItem,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const skin = computed({
      get: () => store.state.appConfig.layout.skin,
    })
    const { resolveUserrolVariant } = configTableUsuarios()
    const { resolveUserGrupoVariant } = configTableUsuarios()
    const { resolveUserrolIcon } = configTableUsuarios()
    return {
      skin,
      resolveUserrolVariant,
      resolveUserrolIcon,
      resolveUserGrupoVariant,
    }
  },
}
</script>

<style>

</style>
